<template>
  <base-modal-bottom
    ref="VerificationPhoneModal"
    class="has-text-centered"
    :isFooter="true"
    :title="title"
  >
    <template #btn-close-icon>
      <div
        class="button-close-custom"
        @click="btnCloseAtivated ? close() : goToLegacyAdmin()"
      >
        <base-icon
          style="margin: 0 auto"
          width="16"
          height="16"
          name="painel/close-icon"
        />
      </div>
    </template>

    <div class="c-modal-phone">
      <div class="margin-bottom">
        <base-icon width="88" height="95" :name="icon" />
      </div>

      <div v-if="isConfirmeModal" class="step-confirmation-number">
        <!-- If number registered -->
        <div v-if="isConfirmeModal && !isRegisterNumber">
          <p
            class="margin-bottom c-modal-phone--max-width c-modal-phone--title"
          >
            <strong>Mais segurança para suas transações</strong>
          </p>

          <p class="margin-bottom c-modal-phone--max-width c-modal-phone--info">
            Para concluir essa transação é necessário confirmar a titularidade
            da sua conta. Enviaremos um código de validação para o número de
            celular cadastrado:
          </p>
        </div>

        <p class="margin-bottom c-modal-phone--max-width c-modal-phone--info">
          <strong v-if="false"
            >Como você gostaria de receber o código de validação?</strong
          >
          Por favor, selecione abaixo por onde gostaria de receber o código
          token:
        </p>

        <ul class="c-modal-phone--max-width c-modal-phone__choise-channel">
          <li>
            <button
              class="c-modal-phone__choise-channel--item"
              @click="submitSendCode('sms')"
              :disabled="isDisable"
            >
              <img :src="smsImage" alt="Enviar por SMS" />
              <p>
                Receber código via SMS <br /><span
                  >no celular
                  {{
                    isConfirmeModal && !isRegisterNumber
                      ? phone_number
                      : numberPhoneRegister
                  }}</span
                >
              </p>
              <img :src="arrowRight" alt="Enviar código por SMS" />
            </button>
          </li>
          <li>
            <button
              :disabled="isDisable"
              class="c-modal-phone__choise-channel--item"
              @click="submitSendCode('whatsapp')"
            >
              <img :src="wppImage" alt="Enviar por WhatsApp" />
              <p>
                Receber código via WhatsApp <br /><span
                  >no celular
                  {{
                    isConfirmeModal && !isRegisterNumber
                      ? phone_number
                      : numberPhoneRegister
                  }}</span
                >
              </p>
              <img :src="arrowRight" alt="Enviar código por Whatsapp" />
            </button>
          </li>
        </ul>
      </div>

      <div v-else class="step-validation-number">
        <p class="margin-bottom c-modal-phone--max-width c-modal-phone--title">
          <strong
            >Digite abaixo o código de 4 dígitos que enviamos a você por
            {{ chnLabel }}</strong
          >
        </p>

        <div class="field-body column c-modal-phone--max-width">
          <div class="field">
            <div class="control c-modal-phone__input-cod" autocomplete="off">
              <input
                ref="key1"
                class="c-modal-phone__input-cod--input"
                v-model="code[0]"
                type="number"
                maxlength="1"
                @keyup="focusNext('key2')"
              />
              <input
                ref="key2"
                class="c-modal-phone__input-cod--input"
                v-model="code[1]"
                type="number"
                maxlength="1"
                @keyup="focusNext('key3')"
              />
              <input
                ref="key3"
                class="c-modal-phone__input-cod--input"
                v-model="code[2]"
                type="number"
                maxlength="1"
                @keyup="focusNext('key4')"
              />
              <input
                ref="key4"
                class="c-modal-phone__input-cod--input"
                v-model="code[3]"
                type="number"
                maxlength="1"
              />
            </div>
            <p class="control c-modal-phone__input-cod--error">
              {{ codeError }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="footer-modal-sms">
        <div class="c-modal-phone__btn-footer">
          <div v-if="!isConfirmeModal" class="step-validation-number">
            <base-button-bottom
              @click.native="submit()"
              :disabled="code == [] || code.length != 4"
              class="is-primary is-big c-modal-phone--max-width-btn c-modal-phone__btn-footer--submit"
              type="button"
            >
              Continuar
            </base-button-bottom>

            <base-button-bottom
              :disabled="time != 0"
              @click.native="resendCode()"
              class="is-primary is-big c-modal-phone--max-width-btn c-modal-phone__btn-footer--send-cod"
              type="button"
            >
              {{ sendCodeAgain }}
            </base-button-bottom>
          </div>

          <p
            v-if="isConfirmeModal"
            class="c-modal-phone--max-width-btn c-modal-phone__btn-footer--change-number"
            @click="changePhone()"
          >
            Alterar número de celular
          </p>
          <p
            v-else
            class="c-modal-phone--max-width-btn c-modal-phone__btn-footer--change-number"
            @click="changeChannel()"
          >
            Tentar de outra forma
          </p>
        </div>
      </div>
    </template>
    <ModalInfoPhone v-if="infoModal" />
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

import ModalInfoPhone from '@/components/Profile/Sms/InfoPhoneModal.vue'

import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'

//images
import wppImage from '@/assets/img/wpp.png'
import smsImage from '@/assets/img/sms.png'
import arrowRight from '@/assets/img/arrow-right.png'

import Sms from '@/lib/api/Sms'
import SmsExternal from '@/lib/api/SmsExternal'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  mixins: [verifyDataUserMixin],

  props: {
    title: {
      type: String,
      default: 'Validação de segurança',
    },
    icon: {
      type: String,
      default: 'account-shield',
    },
    nextStep: {
      type: String,
      default: 'transfer',
    },
    isRegisterNumber: {
      type: Boolean,
      default: false,
    },
    btnCloseAtivated: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BaseModalBottom,
    BaseButtonBottom,
    ModalInfoPhone,
  },

  watch: {
    codeSubmit() {
      this.codeSubmit.split('').length < 4
        ? (this.codeError = 'Código digitado está inválido ou expirado')
        : ''
    },
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
  },

  data() {
    return {
      wppImage,
      smsImage,
      arrowRight,
      time: null,
      second: null,
      min: null,
      chn: null,
      chnLabel: null,
      code: [],
      codeSubmit: null,
      sendCodeAgain: 'Reenviar código',
      codeError: '',
      infoModal: false,
      numberPhone: null,
      isConfirmeModal: true,
      params: null,
      numberPhoneRegister: null,
      phone_number: null,
      countDown: null,
      isDisable: false,
      tokenPassword: null,
      hasDataShopping: null,
    }
  },

  async created() {
    this.code = []
    //if the number has registed
    if (!this.isRegisterNumber) {
      this.hasBtnClose = true
      this.nextStep != 'shopping' ? this.getPhoneNumber() : ''
    }
  },

  methods: {
    open(data) {
      this.$refs.VerificationPhoneModal.open()

      // if first access, before register number phone
      if (this.isRegisterNumber) {
        //format data phone
        this.numberPhoneRegister = data.phone.replace(/\s/g, '')
      } else {
        this.tokenPassword = data

        this.nextStep == 'shopping'
          ? ((this.tokenPassword = data.token),
            (this.hasDataShopping = data.payload),
            this.getPhoneNumberShopping())
          : ''
      }
    },

    close() {
      this.$refs.VerificationPhoneModal.close()
    },

    async getPhoneNumber() {
      const sms = new Sms(this.logonToken)
      const smsResponse = await sms.getPhoneNumber(
        'wallet',
        this.logonToken.token_payload.user_id
      )

      smsResponse.data.receiver_identifier
        ? (this.phone_number = smsResponse.data.receiver_identifier)
        : (this.phone_number = '')
    },

    async getPhoneNumberShopping() {
      if (this.hasDataShopping) {
        const smsExternal = new SmsExternal(this.tokenPassword)
        const smsResponse = await smsExternal.getPhoneNumber(
          'shopping',
          this.hasDataShopping.user_id
        )
        smsResponse.data.receiver_identifier
          ? (this.phone_number = smsResponse.data.receiver_identifier)
          : (this.phone_number = '')
      }
    },

    changePhone() {
      this.isRegisterNumber ? this.close() : (this.infoModal = true)
    },

    changeChannel() {
      clearTimeout(this.countDown)
      this.isConfirmeModal = true
    },

    resendCode() {
      !this.isRegisterNumber ? this.sendCode() : this.sendCodeFirstAccess()
    },

    focusNext(input) {
      this.codeError = ''
      this.$refs[input].focus()
    },

    submitSendCode(data) {
      this.isDisable = true
      this.chn = data
      this.chnLabel = data === 'sms' ? 'SMS' : 'Whatsapp'
      !this.isRegisterNumber ? this.sendCode() : this.sendCodeFirstAccess()
    },

    // function to exact minutes. Ex: 240, 180, 120 etc
    countDownTimer(timeSecond) {
      if (timeSecond) {
        this.time = timeSecond
        this.min = timeSecond / 60 - 1
        this.second = 59
      }

      this.sendCodeAgain =
        'Reenviar código em ' + this.min + ':' + this.formatSecund(this.second)

      if (this.time > 0) {
        this.countDown = setTimeout(() => {
          this.second == 0
            ? ((this.min = this.min - 1), (this.second = 60))
            : ''
          this.second -= 1
          this.time -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.sendCodeAgain = 'Reenviar código'
      }
    },

    formatSecund(second) {
      if (second < 10) {
        return `0${second}`
      } else {
        return second
      }
    },

    getValueToken() {
      this.codeSubmit = ''

      this.code.length < 4
        ? (this.codeError = 'Código digitado está inválido ou expirado')
        : ''

      this.code.forEach((element) => {
        this.codeSubmit += element
      })
    },

    registerPhoneNumber(tokenSMS) {
      const data = {
        source: 'wallet',
        user_id: this.logonToken.token_payload.user_id,
        receiver_identifier: this.numberPhoneRegister,
        channel: this.chn,
      }

      const tokens = `Bearer ${this.logonToken.token}, Bearer ${tokenSMS}`

      const sms = new Sms(this.logonToken)
      // eslint-disable-next-line no-unused-vars
      const smsResponseSetPhone = sms
        .setPhone(tokens, data)
        .then((response) => {
          if (response.data.receiver_identifier) {
            this.params = this.$route.fullPath
            location.reload()
          } else {
            this.codeError = response.data.error.message
          }

          response.status === 422
            ? (this.codeError =
                response.data.error.errors.receiver_identifier.toString())
            : ''
        })
        .catch((error) => {
          console.error(error)
          this.codeError = error.data.data.error.message
        })
    },

    sendCodeFirstAccess() {
      this.codeError = ''
      this.code = []

      const data = {
        source: 'wallet',
        receiver_identifier: this.numberPhoneRegister,
        channel: this.chn,
      }

      const sms = new Sms(this.logonToken)
      // eslint-disable-next-line no-unused-vars
      const smsResponse = sms
        .sendCodeByCellphone(data)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.isDisable = false
          this.isConfirmeModal = false
          this.countDownTimer(response.data.data.expire_in_seconds)
        })
        .catch((error) => {
          this.isDisable = false
          console.error(error)
        })
    },

    sendCode() {
      this.codeError = ''
      this.code = []

      this.nextStep != 'shopping'
        ? this.sendCodeDefault()
        : this.sendCodeShopping()
    },

    sendCodeDefault() {
      const tokens = `Bearer ${this.logonToken.token}, Bearer ${this.tokenPassword}`

      const data = {
        source: 'wallet',
        user_id: this.logonToken.token_payload.user_id,
        channel: this.chn,
      }

      const sms = new Sms(this.logonToken)
      // eslint-disable-next-line no-unused-vars
      const smsResponse = sms
        .sendCode(data, tokens)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.isDisable = false
          this.isConfirmeModal = false
          this.countDownTimer(response.data.data.expire_in_seconds)
        })
        .catch((error) => {
          this.isDisable = false
          console.error(error)
        })
    },

    sendCodeShopping() {
      const data = {
        source: 'shopping',
        user_id: this.hasDataShopping.user_id,
        channel: this.chn,
      }

      const smsExternalApi = new SmsExternal(this.tokenPassword)
      // eslint-disable-next-line no-unused-vars
      const smsResponse = smsExternalApi
        .sendCode(data)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.isDisable = false
          this.isConfirmeModal = false
          this.countDownTimer(response.data.data.expire_in_seconds)
        })
        .catch((error) => {
          this.isDisable = false
          console.error(error)
        })
    },

    async checkCode() {
      const tokens = `Bearer ${this.logonToken.token}, Bearer ${this.tokenPassword}`

      const data = {
        source: 'wallet',
        user_id: this.logonToken.token_payload.user_id,
        code: this.codeSubmit,
        channel: this.chn,
      }

      const sms = new Sms(this.logonToken)
      const smsResponse = await sms.checkCode(data, tokens)

      smsResponse.data.token
        ? (this.$emit('validation-phone', smsResponse.data.token), this.close())
        : (this.codeError =
            'Houve algum problema, tente novamente em instantes!')

      smsResponse.status === 403
        ? (this.codeError = smsResponse.data.error.message)
        : ''
    },

    async checkCodeShopping() {
      const data = {
        source: 'shopping',
        user_id: this.hasDataShopping.user_id,
        code: this.codeSubmit,
        channel: this.chn,
      }

      const sms = new SmsExternal(this.tokenPassword)
      const smsResponse = await sms.checkCode(data)

      smsResponse.data.token
        ? (this.$emit('validation-phone', smsResponse.data.token), this.close())
        : (this.codeError =
            'Houve algum problema, tente novamente em instantes!')

      smsResponse.status === 403
        ? (this.codeError = smsResponse.data.error.message)
        : ''
    },

    async checkCodeFirstAccess() {
      const data = {
        source: 'wallet',
        receiver_identifier: this.numberPhoneRegister,
        code: this.codeSubmit,
        channel: this.chn,
      }

      const sms = new Sms(this.logonToken)
      // eslint-disable-next-line no-unused-vars
      const smsResponse = await sms.checkCodeByCellphone(data)

      smsResponse.data.token
        ? this.registerPhoneNumber(smsResponse.data.token)
        : (this.codeError =
            'Houve algum problema, tente novamente em instantes!')

      smsResponse.status === 403
        ? (this.codeError = smsResponse.data.error.message)
        : ''
    },

    async submit() {
      await this.getValueToken()

      if (!this.isRegisterNumber) {
        this.nextStep != 'shopping'
          ? this.checkCode()
          : this.checkCodeShopping()
      } else {
        this.checkCodeFirstAccess()
      }
    },

    goToLegacyAdmin() {
      if (this.logonToken) {
        window.location.href = `${API_LEGACY_URL}/${this.logonToken.token_payload.wed_id}#/admin`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-modal {
  &__body {
    padding: 32px 16px 8px !important;
  }
}

.c-base-button-bottom {
  position: relative;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
}

.c-modal-phone {
  max-width: 400px !important;
  margin: 0 auto;

  &__choise-channel {
    max-width: 400px !important;
    margin: 0 auto;
    padding: 15px;

    &--item {
      background-color: transparent;
      width: 100%;
      border-radius: 8px;
      border: solid 1px $gray-4;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 16px;
      padding: 15px 20px;
      cursor: pointer;

      &:hover {
        background-color: #bfc8d13d;
      }

      p {
        flex: 1;
        text-align: left;
        padding: 0 20px;
        font-size: 16px;
        color: #5b6674;
        font-weight: bold;

        @media (max-width: 769px) {
          font-size: 14px;
        }

        span {
          font-size: 14px;
          font-weight: normal;

          @media (max-width: 769px) {
            font-size: 13px;
          }
        }
      }
    }
  }

  &--max-width {
    max-width: 450px;
    margin: 0 auto;
    padding-bottom: 12px;
  }

  &--max-width-btn {
    width: 100% !important;
    max-width: 400px;
  }

  &--exemplo {
    font-size: 12px;
  }

  &--title {
    font-size: 18px;
  }

  &--info {
    font-size: 16px;

    span {
      color: $primary;
      font-weight: bold;
    }
  }

  &--number {
    padding-top: 20px;
    font-size: 20px;
    color: #6e7983;
    font-weight: bold;
  }

  &__input-cod {
    display: flex;
    justify-content: center;

    &--input {
      border: 0.0625rem solid $gray-4 !important;
      border-radius: 4px !important;
      margin: 5px !important;
      padding: 0 !important;
      text-align: center !important;
      width: 40px !important;
      height: 40px !important;
    }

    &--error {
      color: $error;
      font-size: 14px;
      text-align: center;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      margin: 0 !important;
      appearance: textfield !important;
    }
  }

  &__btn-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &--submit {
      margin-bottom: 16px;
      width: 100% !important;
      max-width: 400px !important;
      cursor: pointer !important;
    }

    &--send-cod {
      background-color: $gray-5 !important;
      width: 100% !important;
      max-width: 400px !important;
      cursor: pointer !important;
    }

    &--change-number {
      margin-top: 16px;
      font-size: 16px;
      font-weight: 700;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.07;
      letter-spacing: normal;
      color: $support;
      cursor: pointer;
      margin-bottom: 16px;
    }
  }
}

.field-body {
  margin-top: 20px;
}

.button-close-custom {
  width: 40px;
}

.step-validation-number {
  max-width: 450px;
  width: 100%;
}
</style>
